/* eslint-disable no-console */
/* eslint-disable no-plusplus */

import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Select } from 'antd';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { AddDataStatusToItem } from '@common/utils/optionFilterHelper';

function ComMonthSelector({ options, onMonthChange }) {
  const [selectedYear, setSelectedYear] = useState(dayjs().year());
  const [selectedMonth, setSelectedMonth] = useState(null);

  const yearOptions = useMemo(() => {
    const tempList = options?.map((item) => item.year) || [];
    return tempList
      ?.map((item) => ({
        value: item,
        label: String(item),
      }))
      ?.sort((a, b) => b.value - a.value);
  }, [options]);

  const monthOptions = useMemo(() => {
    if (!selectedYear || !options || options.length === 0) return [];
    const tempList = (
      options
        ?.filter((item) => item.year === selectedYear)
        ?.map((item) => item.months) || []
    ).flat();
    return tempList
      ?.map((m) => AddDataStatusToItem(m.yearMonth, m.hasData))
      .sort((a, b) => b.value - a.value);
  }, [selectedYear, options]);

  useEffect(() => {
    if (monthOptions.length > 0) {
      const hasCurrentMonth = monthOptions.find(
        (m) => m.value === dayjs().month() + 1 && m.year === dayjs().year(),
      );
      if (hasCurrentMonth) {
        setSelectedMonth(dayjs().month() + 1);
      }
    }
  }, [monthOptions]);

  useEffect(() => {
    if (selectedYear && selectedMonth && typeof onMonthChange === 'function') {
      onMonthChange(selectedYear, selectedMonth);
    }
  }, [selectedYear, selectedMonth, onMonthChange]);

  const handleYearChange = useCallback((value) => {
    setSelectedYear(value);
    setSelectedMonth(null);
  }, []);

  const handleMonthChange = useCallback((value) => {
    setSelectedMonth(value);
  }, []);

  return (
    <div className="display-flex item-center gap-8px">
      {/* Dropdown 1: Year */}
      <Select
        style={{ width: 120 }}
        value={selectedYear}
        options={yearOptions}
        onChange={handleYearChange}
      />

      {/* Dropdown 2: Month */}
      <Select
        style={{ width: 150 }}
        placeholder="月選択"
        value={selectedMonth}
        options={monthOptions}
        onSelect={handleMonthChange}
      />
    </div>
  );
}

ComMonthSelector.propTypes = {
  options: PropTypes.array,
  onMonthChange: PropTypes.func,
};

ComMonthSelector.defaultProps = {
  options: [],
  onMonthChange: null,
};

export default ComMonthSelector;
